"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
const helpers_1 = require("@tpd-web-common-libs/nodejs-library/dist/src/helpers");
const network_config_1 = require("./network.config");
class Request {
    /**
     *
     * @param url della chiamata api
     * @param params specifiche dell'api. {body: {}, headers: {}, queryParams: {}}
     * @param flagSia se true concatena le informazioni sull' "url_sia" all'url della chiamata
     * @param noBaseUrl se true elimina il baseUrl. Da usare per chiamare api con domini particolari
     * @param areaOverride esegue l'override sull'autenticazione dell'utente.
     */
    constructor(url = "", params = {
        body: {},
        headers: {},
        queryParams: {},
    }, flagSia, noBaseUrl, areaOverride, noStringify) {
        this.url = url;
        this.flagSia = flagSia;
        this.noBaseUrl = noBaseUrl;
        this.areaOverride = areaOverride;
        this.noStringify = noStringify;
        if (flagSia) {
            this.completeUrl = network_config_1.CONFIG.baseInformations["url_sia"].concat(url);
        }
        else {
            this.completeUrl = noBaseUrl
                ? url
                : network_config_1.CONFIG.baseInformations[areaOverride
                    ? areaOverride
                    : helpers_1.LoginHelper.userLogged
                        ? "url_priv"
                        : "url_pub"].concat(url);
            this.body = noStringify ? params.body : JSON.stringify(params.body);
            this.headers = params.headers;
            if (params.queryParams) {
                this.completeUrl += this.createQueryParam(params.queryParams);
            }
        }
    }
    createQueryParam(obj) {
        let queryString = "";
        let notUndefinedCount = 0;
        Object.keys(obj).forEach((key) => {
            if (obj[key]) {
                queryString +=
                    (notUndefinedCount ? "&" : "?") +
                        `${key}=${encodeURIComponent(obj[key])}`;
                notUndefinedCount++;
            }
        });
        return queryString;
    }
}
exports.Request = Request;
